export default __webpack_public_path__ + "static/media/upInActive.9d6bff71.svg";